import { useMemo } from 'react';
import { Box } from '@mui/system';
import { ClickAwayListener, Paper, Popover, useTheme } from '@mui/material';

import { MainCard, Transitions, usePopover } from '@trendiolive/trendio-selfcare-ui-kit';

import { useAppSelector } from 'app/hooks';

import useAuth from 'hooks/useAuth';
import UserMerchantListItem from './UserMerchantListItem';

import { ShopOutlined } from '@ant-design/icons';

export default function UserMerchantsList() {
  const theme = useTheme();

  const { merchant } = useAppSelector((store) => store.merchant);
  const { anchorRef, handleClose, handleOpenClosePopover, open } = usePopover();
  const { user, merchantSwitch } = useAuth();

  const availableMerchants = useMemo(
    () =>
      (user?.roles ?? [])
        .flatMap((role) => (role.merchant && role.merchant.id !== merchant?.id ? [role.merchant] : []))
        .sort((a, b) => a.name.localeCompare(b.name)),
    [merchant?.id, user?.roles]
  );

  if (user?.roles && user?.roles.length <= 1) return null;

  return (
    <Box aria-label="Current User Merchant List">
      <Box
        ref={anchorRef}
        sx={{
          color: open ? theme.palette.primary.main : undefined,
          ':hover': {
            color: theme.palette.primary.main,
            cursor: 'pointer'
          }
        }}
        onClick={() => handleOpenClosePopover()}
      >
        <ShopOutlined />
      </Box>
      <Popover
        anchorEl={anchorRef.current}
        open={open}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <Transitions type="grow" position="top-right" in={open}>
          <Paper sx={{ boxShadow: theme.customShadows.z1, width: 290, minWidth: 240, maxWidth: { xs: 250, md: 290 } }}>
            <ClickAwayListener onClickAway={handleClose}>
              <MainCard elevation={0} border={false} content={false}>
                <>
                  {availableMerchants.map((merchantRole) => (
                    <UserMerchantListItem key={merchantRole.id} merchant={merchantRole} onClick={merchantSwitch} />
                  ))}
                </>
              </MainCard>
            </ClickAwayListener>
          </Paper>
        </Transitions>
      </Popover>
    </Box>
  );
}
